interface Props {

    typing: boolean;

    userName?: string;
}

const TypingIndicator = ({
    typing,
    userName
}: Props) => {

    if (!typing)
        return null;

    return (

        <div
            className="px-3 pb-2 text-muted small"
        >

            {userName ?? "Someone"} is typing...

        </div>

    );
};

export default TypingIndicator;